export default {
  brandColor1: '#cb6ce6',
  complimentaryColor1: '#f0ede5',
  brandColor2: '#9960b7',
  complimentaryColor2: '#f0ede5',
};
